import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { InputAdornment, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import useStyles from "./Styles";
import { SearchMovie } from "../../features/currentGenreOrCategory";
const Search = () => {
  const [query, setQuery] = useState("");
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      dispatch(SearchMovie(query));
    }
  };

  if (location.pathname !== "/") return null;
  return (
    <div className={classes.SearchContainer}>
      <TextField
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
        }}
        onKeyPress={handleKeyPress}
        variant="standard"
        InputProps={{
          className: classes.input,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default Search;
